(function () {
  const root = document.querySelector('.transformer-product');
  if (!root) return;

  const productId = parseInt(root.dataset.productId, 10);

  if (productId) {
    try {
      let recentlyViewedProducts = JSON.parse(localStorage.getItem('theme:recently-viewed-products') || '[]');
      recentlyViewedProducts = recentlyViewedProducts.filter((item) => item !== productId);
      recentlyViewedProducts.unshift(productId);
      localStorage.setItem('theme:recently-viewed-products', JSON.stringify(recentlyViewedProducts));
    } catch (e) {}
  }

  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const animObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
          animObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    root.querySelectorAll('[data-animate]').forEach((el) => animObserver.observe(el));
  } else {
    root.querySelectorAll('[data-animate]').forEach((el) => el.classList.add('animate-in'));
  }

  const featureCarousel = root.querySelector('[data-feature-carousel]');
  if (featureCarousel) {
    const track = featureCarousel.querySelector('[data-carousel-track]');
    const viewport = featureCarousel.querySelector('.trp-feature-carousel__viewport');
    const realSlides = [...track.querySelectorAll('[data-carousel-slide]')];
    const realCount = realSlides.length;

    if (realCount > 0) {
      const segments = [...featureCarousel.querySelectorAll('[data-carousel-seg]')];
      const counter = featureCarousel.querySelector('[data-carousel-counter]');
      const prevBtn = featureCarousel.querySelector('.trp-feature-carousel__arrow--prev');
      const nextBtn = featureCarousel.querySelector('.trp-feature-carousel__arrow--next');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let isInView = false;
      let domIndex = 1;

      const cloneSlide = (slide, position) => {
        const clone = slide.cloneNode(true);
        clone.classList.add('trp-feature-carousel__slide--clone');
        clone.removeAttribute('data-carousel-slide');
        clone.setAttribute('data-carousel-clone', position);
        clone.setAttribute('aria-hidden', 'true');
        return clone;
      };

      track.insertBefore(cloneSlide(realSlides[realCount - 1], 'start'), realSlides[0]);
      track.appendChild(cloneSlide(realSlides[0], 'end'));

      const getSlides = () => [...track.children];

      const logicalIndex = () => {
        const total = getSlides().length;
        if (domIndex === 0) return realCount - 1;
        if (domIndex === total - 1) return 0;
        return domIndex - 1;
      };

      const activeSlide = () => getSlides()[domIndex];

      const updateProgress = (video) => {
        const logIdx = logicalIndex();
        segments.forEach((seg, i) => {
          const fill = seg.querySelector('.trp-feature-carousel__progress-fill');
          seg.classList.toggle('is-complete', i < logIdx);
          if (i < logIdx) {
            fill.style.width = '100%';
          } else if (i > logIdx) {
            fill.style.width = '0%';
          } else if (video && video.duration) {
            fill.style.width = `${(video.currentTime / video.duration) * 100}%`;
          }
        });
      };

      const pauseAll = () => {
        track.querySelectorAll('video').forEach((v) => v.pause());
      };

      const getSlideStep = () => {
        const slide = activeSlide();
        if (!slide) return 0;
        const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return slide.offsetWidth + gap;
      };

      const updatePosition = (animate = true) => {
        if (!track || !viewport) return;
        track.classList.toggle('is-jumping', !animate);
        const step = getSlideStep();
        track.style.transform = `translateX(${-domIndex * step}px)`;
        if (!animate) {
          track.offsetHeight;
          track.classList.remove('is-jumping');
        }
      };

      const setActiveStates = () => {
        const logIdx = logicalIndex();
        getSlides().forEach((slide, i) => slide.classList.toggle('is-active', i === domIndex));
        if (counter) counter.textContent = `${logIdx + 1} / ${realCount}`;
        updateProgress(null);
      };

      const playActive = (reset = true) => {
        if (!isInView || reducedMotion) return;
        const video = activeSlide()?.querySelector('video');
        if (!video) return;
        if (reset) video.currentTime = 0;
        video.play().catch(() => {});
      };

      const jumpIfNeeded = () => {
        const slides = getSlides();
        const lastDom = slides.length - 1;
        if (domIndex === 0) {
          domIndex = lastDom - 1;
          setActiveStates();
          updatePosition(false);
          pauseAll();
          playActive(true);
        } else if (domIndex === lastDom) {
          domIndex = 1;
          setActiveStates();
          updatePosition(false);
          pauseAll();
          playActive(true);
        }
      };

      const goToDom = (index, { animate = true, play = true, reset = true } = {}) => {
        domIndex = index;
        setActiveStates();
        pauseAll();
        updatePosition(animate);
        if (play) playActive(reset);
      };

      const goToLogical = (index, opts = {}) => {
        goToDom(index + 1, opts);
      };

      const goNext = () => {
        domIndex += 1;
        setActiveStates();
        pauseAll();
        updatePosition(true);
        playActive(true);
      };

      const goPrev = () => {
        domIndex -= 1;
        setActiveStates();
        pauseAll();
        updatePosition(true);
        playActive(true);
      };

      track.addEventListener('transitionend', (e) => {
        if (e.target !== track || e.propertyName !== 'transform') return;
        jumpIfNeeded();
      });

      track.querySelectorAll('video').forEach((video) => {
        video.addEventListener('timeupdate', () => {
          if (activeSlide()?.contains(video)) updateProgress(video);
        });
        video.addEventListener('ended', () => {
          if (activeSlide()?.contains(video) && !reducedMotion) goNext();
        });
      });

      prevBtn?.addEventListener('click', goPrev);
      nextBtn?.addEventListener('click', goNext);
      segments.forEach((seg) => {
        seg.addEventListener('click', () => goToLogical(parseInt(seg.dataset.carouselSeg, 10)));
      });

      window.addEventListener('resize', () => updatePosition(false));

      const carouselObserver = new IntersectionObserver(([entry]) => {
        isInView = entry.isIntersecting;
        if (isInView && !reducedMotion) {
          playActive(false);
        } else {
          pauseAll();
        }
      }, { threshold: 0.35 });

      carouselObserver.observe(featureCarousel);
      setActiveStates();
      updatePosition(false);
    }
  }

  const coloursSection = root.querySelector('[data-colours-section]');
  if (coloursSection) {
    const swatches = [...coloursSection.querySelectorAll('.trp-colour-swatch')];
    const showcaseWrap = coloursSection.querySelector('[data-colour-showcase-wrap]');
    const showcaseImgA = coloursSection.querySelector('[data-colour-showcase-img="a"]');
    const showcaseImgB = coloursSection.querySelector('[data-colour-showcase-img="b"]');
    const showcaseInfo = coloursSection.querySelector('[data-colour-showcase-info]');
    const showcaseTitle = coloursSection.querySelector('[data-colour-showcase-title]');
    const showcaseBody = coloursSection.querySelector('[data-colour-showcase-body]');
    const reducedMotionColours = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let activeImg = showcaseImgA;
    let idleImg = showcaseImgB;

    const crossfadeImage = (src, alt) => {
      if (!activeImg || !idleImg || !showcaseWrap || !src) return;
      if (activeImg.src === src) return;

      showcaseWrap.classList.add('is-loading', 'is-transitioning');
      idleImg.removeAttribute('hidden');

      const reveal = () => {
        activeImg.classList.remove('is-visible');
        activeImg.setAttribute('hidden', '');
        idleImg.classList.add('is-visible');
        idleImg.removeAttribute('hidden');
        idleImg.alt = alt;
        const prev = activeImg;
        activeImg = idleImg;
        idleImg = prev;
        showcaseWrap.classList.remove('is-loading');
        setTimeout(() => showcaseWrap.classList.remove('is-transitioning'), 650);
      };

      if (reducedMotionColours) {
        idleImg.src = src;
        reveal();
        return;
      }

      const loader = new Image();
      loader.onload = () => {
        idleImg.src = src;
        requestAnimationFrame(reveal);
      };
      loader.src = src;
    };

    const updateShowcaseText = (title, body) => {
      if (!showcaseInfo) {
        if (showcaseTitle && title) showcaseTitle.textContent = title;
        if (showcaseBody && body) showcaseBody.textContent = body;
        return;
      }
      showcaseInfo.classList.add('is-updating');
      setTimeout(() => {
        if (showcaseTitle && title) showcaseTitle.textContent = title;
        if (showcaseBody && body) showcaseBody.textContent = body;
        showcaseInfo.classList.remove('is-updating');
      }, reducedMotionColours ? 0 : 180);
    };

    const activateSwatch = (swatch) => {
      swatches.forEach((s) => {
        s.classList.remove('is-active');
        s.setAttribute('aria-selected', 'false');
      });
      swatch.classList.add('is-active');
      swatch.setAttribute('aria-selected', 'true');

      const { secondary, title, body, finish } = swatch.dataset;
      crossfadeImage(secondary, title || finish || '');
      updateShowcaseText(title, body);

      if (finish) {
        root.querySelectorAll('variant-picker input[type="radio"], variant-picker option').forEach((input) => {
          const label = (input.value || input.textContent || '').trim();
          if (label.toLowerCase().includes(finish.toLowerCase()) || finish.toLowerCase().includes(label.toLowerCase())) {
            if (input.tagName === 'OPTION') input.selected = true;
            else {
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        });
      }
    };

    swatches.forEach((swatch) => {
      swatch.addEventListener('click', () => activateSwatch(swatch));
    });
  }

  root.querySelectorAll('.trp-faq__tab').forEach((tab) => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.tab;
      root.querySelectorAll('.trp-faq__tab').forEach((t) => t.classList.remove('is-active'));
      root.querySelectorAll('.trp-faq__panel').forEach((p) => p.classList.remove('is-active'));
      tab.classList.add('is-active');
      root.querySelector(`[data-panel="${target}"]`)?.classList.add('is-active');
    });
  });

  const lightbox = document.getElementById('trp-lightbox');
  const lightboxVideo = lightbox?.querySelector('video');
  root.querySelectorAll('[data-trp-lightbox]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      if (!lightbox || !lightboxVideo) return;
      lightboxVideo.src = trigger.dataset.trpLightbox;
      lightbox.classList.add('is-open');
      lightboxVideo.play().catch(() => {});
    });
  });
  lightbox?.querySelector('.trp-lightbox__close')?.addEventListener('click', () => {
    lightbox.classList.remove('is-open');
    if (lightboxVideo) {
      lightboxVideo.pause();
      lightboxVideo.removeAttribute('src');
    }
  });
  lightbox?.addEventListener('click', (e) => {
    if (e.target === lightbox) {
      lightbox.classList.remove('is-open');
      if (lightboxVideo) {
        lightboxVideo.pause();
        lightboxVideo.removeAttribute('src');
      }
    }
  });

  root.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      const id = link.getAttribute('href').slice(1);
      const target = document.getElementById(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  root.querySelectorAll('.trp-hero__video, .trp-fluid-row__image video').forEach((video) => {
    video.play().catch(() => {});
  });
})();
